/** Onboarding editor test ids — mirrored in @test-kit CANVAS (keep in sync). */
export const ONBOARDING_EDITOR_TEST_IDS = {
  deployWebBtn: 'canvas-deploy-web-btn',
  /** Actions → Theme → "Change theme…" (admin only) — mirrored in @test-kit ONBOARDING_THEME. */
  changeThemeMenuItem: 'onboarding-actions-change-theme',
} as const;

/**
 * Onboarding settings drawer (gear in the Onboardings list header) — mirrored in @test-kit
 * ONBOARDING_LIST.settingsBtn and ONBOARDING_SETTINGS (keep in sync). The drawer sections keep the
 * Integrations accordion ids (`integrations-section-fonts`, `integrations-section-locales`).
 */
export const ONBOARDING_SETTINGS_TEST_IDS = {
  settingsBtn: 'onb-settings-btn',
  drawer: 'onb-settings-drawer',
  close: 'onb-settings-close',
  empty: 'onb-settings-empty',
  sectionFonts: 'integrations-section-fonts',
  contentFonts: 'integrations-content-fonts',
  sectionLocales: 'integrations-section-locales',
  contentLocales: 'integrations-content-locales',
} as const;
